/**
 * @generated SignedSource<<5eeba414244afd9deaae66c2d1dcc327>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RingSizeDisplay_item$data = {
  readonly isRingItem: boolean | null;
  readonly " $fragmentType": "RingSizeDisplay_item";
};
export type RingSizeDisplay_item$key = {
  readonly " $data"?: RingSizeDisplay_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"RingSizeDisplay_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RingSizeDisplay_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRingItem",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "6b52a20a733e42e7c2d55dcb05a2009c";

export default node;
